import { Controller } from "@hotwired/stimulus"
const DUO_VERIFY_REFRESH_INTERVAL = 2000

export default class extends Controller {

  connect() {
    setTimeout(function(){window.location = location.toString()}, DUO_VERIFY_REFRESH_INTERVAL)
  }
}
